export default __webpack_public_path__ + "static/media/q1.81c9ea67.png";